import React, { MouseEventHandler } from "react";
import { Link } from "react-router-dom";
import { COREButton } from "../../COREDesignSystem/Action/COREButton";
import { COREIcon } from "../../COREDesignSystem/Content/COREIcon";
import { generateTestId } from "../testids/testids";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";

export const BackToHomeButton: React.FC<{
  onClick?: MouseEventHandler<HTMLButtonElement>;
  path?: string;
}> = ({ onClick, path = "/" }) => {
  return (
    <Link to={path}>
      <COREButton
        onClick={onClick}
        testID={generateTestId("page", "core-error-back-to-home-btn")}
        danger
        icon={
          <COREIcon
            icon={icon({ name: "arrow-left", style: "regular" })}
            size="xs"
          />
        }
        type="primary"
      >
        BACK TO HOME
      </COREButton>
    </Link>
  );
};
